export enum ContentSeas {
  NONE,
  MEDITERRANEAN = 'Mediterranean',
  RED = 'Red'
}
